<section *ngIf="form" class="panel inner-panel panel-product-price">
    <div [formGroup]="formProductCurrency" class="panel-wrapper">
        <div formArrayName="currencies" class="panel-collection">
            <div [formGroupName]="$index" *ngFor="let item of collectionOfProductCurrency; let $index=index;" [class]="'panel-inner'" [ngClass]="{'plan-currency--first': $index == 0}">
                <div class="panel-head">
                    <mat-form-field class="custom-mat-form-field field-price-model size size1of1">
                        <mat-label>Price Model</mat-label>
                        <mat-select required #priceModel formControlName="priceModel"
                            (selectionChange)="onChangePriceModel($event.value, $index)" disableOptionCentering="true"
                            panelClass="custom-mat-select-panel list-currency" class="custom-mat-select">
                            <mat-option *ngFor="let priceModel of collectionOfPriceModel" [value]="priceModel.value" class="custom-mat-option">{{ priceModel.label }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="panel-action">
                        <button mat-stroked-button (click)="removeProductPrice($index)" color="primary" disableRipple="true" class="custom-mat-button button-remove button-remove-block">Remove Price</button>
                    </div>
                </div>
                <div class="panel-body">
                    <section [@onRowStatusChange]="statusPriceModelOpt2[$index]" class="message message-row">
                        <div class="message-wrapper info">
                            <div class="message-inner">
                                <mat-icon svgIcon="ico-help-faq" class="custom-mat-icon ico-size ico-xs"></mat-icon>
                                <p class="label-message-detail" *ngIf="priceModel.value == '2'">Charge each unit based on the price of its corresponding tier.</p>
                                <p class="label-message-detail" *ngIf="priceModel.value == '3'">Charge all units based on the price of the highest tier reached.</p>
                                <p class="label-message-detail" *ngIf="priceModel.value == '4'">Charge a fixed price based on the highest tier reached.</p>
                            </div>
                        </div>
                    </section>
                    <div class="form-row row-item-amount">
                        <mat-form-field class="custom-mat-form-field field-currency">
                            <mat-label>Currency</mat-label>
                            <mat-select formControlName="companyCurrencyId" disableOptionCentering="true" panelClass="custom-mat-select-panel list-currency" class="custom-mat-select select-currency">
                                <mat-option *ngFor="let currency of collectionOfCompanyCurrency" [value]="currency.id" class="custom-mat-option option-currency">{{currency.currency.iso3}}<img src="{{currency.currency.flag}}" width="24px" height="auto"></mat-option>
                            </mat-select>
                        </mat-form-field>
                        <div [@onColumnStatusChange]="statusPriceModelOpt1[$index]" class="form-row-inner">
                            <mat-form-field floatLabel="always" class="custom-mat-form-field field-amount">
                                <mat-label>Price (per unit)</mat-label>
                                <input matInput formControlName="price" placeholder="0,000.00">
                                <span matPrefix>$</span>
                            </mat-form-field>
                        </div>
                        <div [@onColumnStatusChange]="statusPriceModelOpt2[$index]" class="form-row-inner">
                            <mat-form-field floatLabel="always" class="custom-mat-form-field field-number-unit">
                                <mat-label>Starting Qty</mat-label>
                                <input matInput placeholder="0" value="1">
                                <span matSuffix>units</span>
                            </mat-form-field>
                            <mat-form-field floatLabel="always" class="custom-mat-form-field field-number-unit">
                                <mat-label>Ending Qty</mat-label>
                                <input matInput placeholder="Unlimited">
                                <span matSuffix>units</span>
                            </mat-form-field>
                            <mat-form-field floatLabel="always" class="custom-mat-form-field field-amount">
                                <mat-label>Price (per unit)</mat-label>
                                <input matInput placeholder="0,000.00">
                                <span matPrefix>$</span>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="form-row row-item-setup">
                        <mat-form-field class="custom-mat-form-field field-setup-option">
                            <mat-label>Setup Fee</mat-label>
                            <mat-select required #productSetupFee formControlName="setupFeeOption" (selectionChange)="onChangeSetupFeeOption($event.value, $index)" disableOptionCentering="true" panelClass="custom-mat-select-panel list-currency" class="custom-mat-select">
                                <mat-option *ngFor="let productSetupFeeOption of collectionOfProductSetupFee" [value]="productSetupFeeOption.value" class="custom-mat-option">{{ productSetupFeeOption.label }}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field floatLabel="always" class="custom-mat-form-field field-amount field-price-setup">
                            <mat-label>One-Time Setup Fee</mat-label>
                            <input matInput formControlName='setupFeeAmount' placeholder="0,000.00">
                            <span matPrefix>$</span>
                        </mat-form-field>
                    </div>
                    <div class="form-row row-checkbox">
                        <mat-checkbox disableRipple="true" disabled class="custom-mat-checkbox rounded checkbox--with--description" color="primary">
                            <span class="typo semi-condensed fw400">Collect Tax</span>
                            <span class="typo semi-condensed fw300 label">Tax will be collected on this charge according to your tax configuration.</span>
                        </mat-checkbox>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
